<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M10.9373 9.1875H9.62476V5.30273L3.49976 11.4277L2.57202 10.5L8.69702 4.375H4.81226V3.0625H10.9373V9.1875Z"
    fill="currentColor"
  />
</svg>
